import React from 'react';
import fixbuildLogo from '../../assets/images/Experience/fixbuildlogo.png';

const experienceData = [
   {
      id: 1,
      role: 'Founder',
      company: 'FixBuild Core X',
      type: 'Mobile App & Security Developer',
      duration: '2024 — Present',
      bullets: [
         'Building Android mobile applications across multiple domains in Java and Kotlin.',
         'C++ security layer for apps that require strong protection.',
         'VPN tunnel cores using C, Go, and C++',
         'Protocols: WireGuard, V2Ray, OpenVPN, SSH, DNSTT, UDP.',
         'Server-side security for backend infrastructure.',
      ],
      current: true,
   },
   {
      id: 2,
      role: 'Lead Developer',
      company: 'Nextin Digital',
      type: 'App & Website Management',
      duration: '2023 — 2024',
      bullets: [
         'Managed the app and company website end-to-end.',
         'Handled website updates, bug fixes, and feature enhancements.',
         'Manage their personal automation scripts and bots for various tasks.',
      ],
      current: false,
   },
   {
      id: 3,
      role: 'App Developer',
      company: 'Mobixa Labs',
      type: 'Android App Development',
      duration: '2022 — 2023',
      bullets: [
         'Debug, test, and fix bugs to ensure smooth app performance.',
         'Optimize apps for speed, performance, and scalability.',
         'Implement app security features to protect data and prevent misuse.',
      ],
      current: false,
   },
];

const ExperienceSection = () => {
   return (
      <div className="relative">
         {/* Vertical line */}
         <div className="pointer-events-none absolute left-[19px] top-3 bottom-3 w-px bg-gradient-to-b from-brand-500/60 via-zinc-300/60 to-transparent dark:via-zinc-700/60" />

         <ul className="flex flex-col gap-4">
            {experienceData.map(({ id, role, company, type, duration, bullets, current }) => (
               <li key={id} className="relative pl-12 group">
                  {/* Node */}
                  <span className="absolute left-2 top-5 flex h-6 w-6 items-center justify-center rounded-full bg-white dark:bg-zinc-900 ring-2 ring-brand-500/60 shadow-soft transition-all group-hover:ring-brand-500">
                     <span className="h-2 w-2 rounded-full bg-brand-500" />
                     <span className="absolute inline-flex h-full w-full rounded-full bg-brand-400/40 opacity-0 group-hover:opacity-100 group-hover:animate-pulseRing" />
                  </span>

                  {/* Connector line: circle right-edge → card left-edge */}
                  <span className="absolute left-8 top-[30px] h-px w-4 origin-left scale-x-0 group-hover:scale-x-100 bg-gradient-to-r from-brand-500 to-brand-400 transition-transform duration-200" />

                  <div className="glass-card hover-card p-4 sm:p-5">
                     <div className="flex flex-wrap items-start justify-between gap-3">
                        <div className="flex items-center gap-3 min-w-0">
                           <div className="grid h-11 w-11 place-items-center rounded-xl overflow-hidden bg-white dark:bg-zinc-800 ring-1 ring-zinc-200/80 dark:ring-zinc-700/60 shadow-soft">
                              {id === 1
                                 ? <img src={fixbuildLogo} alt="FixBuild Core X" className="h-full w-full object-contain" />
                                 : <span className="font-bold text-white bg-gradient-to-br from-indigo-500 via-violet-500 to-emerald-500 h-full w-full grid place-items-center">{company.charAt(0)}</span>
                              }
                           </div>
                           <div className="min-w-0">
                              <p className="font-display text-base font-bold leading-tight">{company}</p>
                              <p className="text-[12px] font-semibold leading-tight mt-0.5">
                                 <span className="bg-gradient-to-r from-brand-500 to-emerald-400 bg-clip-text text-transparent">{role}</span>
                              </p>
                              <p className="text-[11.5px] text-zinc-500 dark:text-zinc-400 leading-tight mt-0.5">
                                 {type}
                              </p>
                           </div>
                        </div>
                        <div className="flex flex-col items-end gap-1.5 shrink-0">
                           <span className="text-[11px] font-mono text-zinc-500 dark:text-zinc-400 whitespace-nowrap">
                              {duration}
                           </span>
                           {current && (
                              <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/10 px-2 py-0.5 text-[10px] font-semibold text-emerald-600 dark:text-emerald-400 ring-1 ring-emerald-500/20">
                                 <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                 Current
                              </span>
                           )}
                        </div>
                     </div>
                     <ul className="mt-3 space-y-1.5">
                        {bullets.map((b) => (
                           <li
                              key={b}
                              className="relative pl-4 text-[12.5px] leading-relaxed text-zinc-600 dark:text-zinc-400"
                           >
                              <span className="absolute left-0 top-2 h-1 w-1 rounded-full bg-brand-500" />
                              {b}
                           </li>
                        ))}
                     </ul>
                  </div>
               </li>
            ))}
         </ul>
      </div>
   );
};

export default ExperienceSection;
